module.exports = __webpack_public_path__ + "images/shortleaseland_small90d27421b891e347875b0012e1059ef2.png";